/*
  FormattedMessages.js - FormattedMessages for Sent Component
*/

// NPM MODULES
import React from 'react';
import { FormattedMessage } from 'react-intl';

const FormattedMessages = {
  backText: (
    <FormattedMessage id="Sent.backText" defaultMessage="Back to Sent List" />
  ),
  backFailedText: (
    <FormattedMessage
      id="Failed.backText"
      defaultMessage="Back to Failed List"
    />
  ),
  cancelPendingMessage: (
    <FormattedMessage
      id="Sent.cancelPendingMessage"
      defaultMessage="Cancel Pending Message"
    />
  ),
  queuedHeader: (
    <FormattedMessage id="Sent.queuedHeader" defaultMessage="Queued" />
  ),
  sentHeader: <FormattedMessage id="Sent.sentHeader" defaultMessage="Sent" />,
  failedHeader: (
    <FormattedMessage id="Failed.failedHeader" defaultMessage="Failed" />
  ),
  toHeader: <FormattedMessage id="Sent.toHeader" defaultMessage="To" />,
  statusHeader: (
    <FormattedMessage id="Sent.statusHeader" defaultMessage="Status" />
  ),
  errorCodeHeader: (
    <FormattedMessage id="Sent.errorCodeHeader" defaultMessage="Error Code" />
  ),
  errorTextHeader: (
    <FormattedMessage id="Sent.errorTextHeader" defaultMessage="Error Text" />
  ),
  encodingHeader: (
    <FormattedMessage id="Sent.encodingHeader" defaultMessage="Encoding" />
  ),
  messageHeader: (
    <FormattedMessage id="Sent.messageHeader" defaultMessage="Message" />
  ),
  searchingText: (
    <FormattedMessage id="App.SearchingText" defaultMessage="Searching..." />
  ),
  searchButton: (
    <FormattedMessage id="Global.SearchButton" defaultMessage="Search" />
  ),
  clearFilters: (
    <FormattedMessage id="Admin.Clear" defaultMessage="Clear Filters" />
  ),
  dateTimeText: (
    <FormattedMessage id="Websms.DateTimeText" defaultMessage="Date/Time" />
  ),
  fromText: <FormattedMessage id="websms.FromText" defaultMessage="From" />,
  toText: <FormattedMessage id="Websms.ToText" defaultMessage="To" />,
  name: <FormattedMessage id="Websms.Name" defaultMessage="Name" />,
  messageText: (
    <FormattedMessage id="Websms.MessageText" defaultMessage="Message" />
  ),
  statusText: (
    <FormattedMessage id="Websms.StatusText" defaultMessage="Status" />
  ),
  noResult: (
    <FormattedMessage
      id="Reports.NoResult"
      defaultMessage="No results found."></FormattedMessage>
  ),
  filterNote: (
    <FormattedMessage
      id="Websms.filterNoteError"
      defaultMessage="NOTE: Numbers should be entered as only digits, no spaces or
      +."
    />
  ),
};

export default FormattedMessages;
